import React from "react";
import { listItemMinHeight } from "../../../../components/Lists/ListItems/shared/ListItemCanvas";
import { ShimmerLine } from "../../../../components/Shimmer/ShimmerLine/ShimmerLine";
import { SlotStack, SlotStackItem } from "../../../../components/Stacks/SlotStack/SlotStack";
import { Stack, StackItem } from "../../../../components/Stacks/Stack/Stack";
import { ViewportType } from "../../../../shared/constants";
import { ViewportSlots } from "../../../../shared/utilities";
import { useViewport } from "../../../../styles";

const lineWidth = 120;
const lineHeight = 12;
const defaultListItemPadding = "0 16px";
const mediaBoxLength = 32;

const availableLimitSlotCounts: ViewportSlots = {
    "m": 0,
    "l": 2,
    "xl": 3,
    "xxl": 2,
    "xxxl": 2
};

export const AppListItemShimmer: React.FC = () => {
    const viewportType: ViewportType = useViewport();

    if (viewportType === "s") {
        return (
            <Stack backgroundColor="neutralHigh" height={listItemMinHeight} padding={defaultListItemPadding} >
                <Stack horizontal={true} childrenGap={"16px"} verticalAlign="center">
                    <StackItem>
                        <ShimmerLine width={mediaBoxLength} height={mediaBoxLength} />
                    </StackItem>
                    <StackItem>
                        <ShimmerLine width={lineWidth} height={lineHeight} />
                    </StackItem>
                </Stack>
            </Stack>
        );
    } else {
        const totalSlots = 12, weekSlotCount = 6;
        const availableLimitSlotCount = availableLimitSlotCounts[viewportType] ?? 0;
        return (
            <SlotStack backgroundColor="neutralHigh" height={listItemMinHeight} padding={defaultListItemPadding} totalSlots={totalSlots} verticalAlign="center">
                <SlotStackItem slots={weekSlotCount}>
                    <Stack horizontal={true} childrenGap={"16px"} verticalAlign="center">
                        <StackItem>
                            <ShimmerLine width={mediaBoxLength} height={mediaBoxLength} />
                        </StackItem>
                        <StackItem>
                            <ShimmerLine width={lineWidth} height={lineHeight} />
                        </StackItem>
                    </Stack>
                </SlotStackItem>
                {viewportType !== "m" && (
                    <SlotStackItem slots={availableLimitSlotCount}>
                        <ShimmerLine width={lineWidth} height={lineHeight} />
                    </SlotStackItem>
                )}
            </SlotStack>
        );
    }
};
